// Floating WhatsApp action button — bottom-right, links direct to chat with LAC
export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/447538963090?text=Hi%20LAC%2C%20I%27d%20like%20to%20enquire%20about%20a%20booking."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat with LAC on WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white flex items-center justify-center shadow-[0_0_30px_rgba(37,211,102,0.45)] transition-all hover:scale-110"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7" fill="currentColor">
        <path d="M19.11 17.21c-.27-.13-1.59-.78-1.83-.87-.25-.09-.43-.13-.6.13-.18.27-.69.87-.84 1.04-.16.18-.31.2-.57.07-.27-.14-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.49-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.32.4-.48.13-.16.18-.27.27-.46.09-.18.04-.34-.02-.48-.07-.13-.6-1.45-.83-1.99-.22-.52-.44-.45-.6-.46h-.51c-.18 0-.46.07-.7.34-.24.27-.92.9-.92 2.19s.94 2.55 1.07 2.72c.13.18 1.85 2.83 4.49 3.97.63.27 1.12.43 1.5.55.63.2 1.2.17 1.65.1.5-.07 1.59-.65 1.81-1.27.22-.62.22-1.16.16-1.27-.07-.11-.24-.18-.51-.31zM16.03 4C9.4 4 4 9.4 4 16.03c0 2.13.56 4.21 1.62 6.04L4 28l6.07-1.59A12.03 12.03 0 0 0 16.03 28C22.66 28 28 22.66 28 16.03 28 9.4 22.66 4 16.03 4z"/>
      </svg>
    </a>
  );
}
